import customSetup from './modules/customSetup/store'
export default { customSetup }